export function SubgroupHeader({
  title,
  count,
  positionLabel
}: {
  title: string;
  count: number;
  positionLabel: string;
}) {
  return (
    <div className="rounded-md border border-zeb-muted bg-zeb-surface px-4 py-3 flex items-center justify-between gap-4 shadow-zeb-xs">
      <div className="min-w-0">
        <div className="text-note font-medium tracking-normal text-zeb-primary">
          {positionLabel}
        </div>
        <div
          className="text-body-sm text-zeb-tertiary truncate"
          style={{ fontFamily: 'var(--font-heading)', fontWeight: 700, letterSpacing: '-0.02em' }}>
          {title}
        </div>
      </div>
      <div className="text-xs tabular-nums text-zeb-gray-500 shrink-0">{count} Aussagen</div>
    </div>
  );
}
